<template>
  <div v-if="viewEmployeeAwardsRegional" class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="EMPLOYEE RECOGNITION"></ContentHeader>
        <section>
          <div class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div class="px-3 pb-3">
              <br>
              <h4 class="mb-3">{{NominationLabel}}</h4>
              <div v-if="!madeNomination" class="row form-group clearfix">
                <div class="col-md-3 col-lg-3 col-xl-3 mt-3">
                  <label class="h6 text-right" width="100%">
                    Region
                  </label>
                </div>
                <div class="col-md-8 col-lg-8 col-xl-8">
                  <select v-model="selectedRegionOption" class="form-control mr-2" @change="displaySelectForm('Region')">
                    <option class="list-group-item" value="Select Region">Select Region</option>
                    <option v-for="region in RegionList" :key="region" class="list-group-item" :value="region">
                    {{ region }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="!madeNomination" class="row form-group clearfix">
                <div class="col-md-3 col-lg-3 col-xl-3 mt-3">
                  <label class="h6 text-right" width="100%">
                    Country
                  </label>
                </div>
                <div class="col-md-8 col-lg-8 col-xl-8">
                  <select v-model="selectedCountryOption" class="form-control mr-2" @change="displaySelectForm('Country')">
                    <option class="list-group-item" value="Select Country">Select Country</option>
                    <option v-for="country in CountryList" :key="country" class="list-group-item" :value="country">
                    {{ country }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="award.include_nomination_form[0] === 'Yes'" v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
              <div v-if="award.nomination_event_time_frame.length > 0">
                <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                  <li class="h6">
                    <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                    {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                  </li>
                </ul>
              </div>
              <div v-if="madeNomination" class="px-3 pb-3">
                <div class="alert alert-success" role="alert">
                  Congratulations, you've nominated:
                  <ul>
                    <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                    <strong>{{teams.name}}</strong> from {{teams.country}} -
                    Employee number: <strong>{{teams.employeeNum}}</strong><br>
                    Country: <strong>{{selectedCountryOption}}</strong><br>
                    Region: <strong>{{selectedRegionOption}}</strong><br>
                    </li>
                  </ul>
                </div>
                <button type="button" name="button" class="btn btn-primary" v-on:click="reload()">Nominate someone else</button>
              </div>
              <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length && displayForm> 0 && !madeNomination" class="px-3 pb-3">
                <h4 class="mb-3">{{NominationLabel}}</h4>
                <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                  <div class="input-group input-group-lg mb-4">
                      <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address" prepend="" ></vue-bootstrap-typeahead>
                      <div class="input-group-append">
                      <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="setNominee()">{{NominationButtonText}}</button>
                      </div>
                  </div>
                </form>
                <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
                  <div class="p-3 mb-2 bg-primary text-white border border-primary font-weight-bold mt-1" v-if="NominationTeamNames.length === 1">Continue to add names if you would like to complete a team nomination for Teams nomination</div>
                    <transition name="grow">
                    <div v-if="showNominationForm || NominationTeamNames.length > 0">
                      <hr>
                      <strong>You are nominating:</strong><br>
                      <div v-if="isTeamAwards">
                      <ul>
                        <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                        <strong>{{teams.name}}</strong> from {{teams.country}} -
                        Employee number: <strong>{{teams.employeeNum}}</strong><br>
                        Country: <strong>{{selectedCountryOption}}</strong><br>
                        Region: <strong>{{selectedRegionOption}}</strong><br>
                        <button type="button" class="btn btn-link p-0" v-on:click="removeTeamNominee(teams)">X Remove</button>
                        </li>
                      </ul>
                      </div>
                      <hr>
                      <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                        <div v-for="formField in nominationFields" v-bind:key="formField.index">
                          <NominationField
                          :type="formField.type"
                          :description="formField.description"
                          :secondary-description="formField.secondaryDescription"
                          :description-lvl-two="formField.description_lvl_two"
                          :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                          :is-required="formField.isRequired"
                          :checkbox-labels="formField.checkboxLabels"
                          v-on:updatedFieldContent="fieldUpdated($event)"
                          :validationMethod="formField.validationMethod"
                          :displayField="formField.display_field"
                          :error-class="formField.errorClass">
                          </NominationField>
                        </div>
                        <div class="row py-1">
                          <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                            <div class="form-group form-check">
                              <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                              <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                              <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row pt-2 mb-4">
                          <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                          <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </transition>
                <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
              </div>
              <div v-if="award.include_nomination_form[0] === 'No'">
                <div class="p-4">
                  <h4>Form Currently Unavailable</h4>
                  <hr>
                  <p>We're sorry, but the form you are trying to access is currently unavailable. If you have any questions or concerns, please don't hesitate to contact our HR team for assistance.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
          <div class="card-body" v-html="award.additional_content[0]"></div>
        </div>
      </div>
    </transition>
  </div>
  <div v-else>
    <!--h5> You do not have permission to access this page. Please contact HR team to provide role.</h5-->
  </div>
</template>
  
  <script>
  import ContentHeader from '@/components/ContentHeader'
  import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
  import WordpressRestURI from '@/helpers/WordpressRestURI.js'
  import ADauthentication from '@/helpers/ADauthentication.js'
  import NominationNotification from '@/helpers/NominationNotification.js'
  import ChildNominationEventsList from '@/components/ChildNominationEventsList'
  import NominationField from '@/components/NominationField'
  import Loading from '@/components/Loading'
  import PreContentHeader from '@/components/PreContentHeader'
  import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
        userDetails: [],
        award: [],
        errors: [],
        contentReady: false,
        contentLoadError: '',
        nominationContent: [],
        nominationFields: [],
        nominatedPerson: '',
        madeNomination: false,
        termsCheckbox: false,
        validatedNominee: '',
        showNominationForm: false,
        creatingNomination: false,
        createNominationError: '',
        searchingForEmployee: false,
        searchingForEmployeeError: '',
        isContractorErrorSet: true,
        isTeamAwards: false,
        submitClicked: true,
        NominationButtonText: 'Nominate',
        NominationLabel: 'Nominate an Employee for this Award',
        NominationPlaceholder: 'Search by name and surname or email address...',
        NominationTeamNames: [],
        NominationTeamsContent: [],
        nomineesList: [],
        employeeHierarchy: {},
        options: [],
        selectedOption: '',
        supportingDocList: [],
        supportingDocLength: 0,
        RegionList: [],
        CountryList: [],
        displayForm: false,
        selectedRegionOption: 'Select Region',
        selectedCountryOption: 'Select Country',
        CountryAssoc: []
      }
    },
    components: {
      PreContentHeader,
      ContentHeader,
      ChildNominationEventsList,
      NominationField,
      Loading,
      vueBootstrapTypeahead
    },
    computed: {
      ...mapGetters([
        'viewEmployeeAwardsRegional'
      ])
    },
    methods: {
      displaySelectForm: function(type) {
        if (this.madeNomination == true) {
          this.reload()
        }
        this.removeNominee()
        if (this.selectedRegionOption == 'Select Region') {
          this.displayForm = false
          this.CountryList = []
          this.selectedCountryOption = 'Select Country'
        } else {
          const selected = this.selectedRegionOption.toLowerCase().trim()
          console.log(' selected ', selected)
          const matchedKey = Object.keys(this.countryAssoc).find(
            key => key.toLowerCase().trim() === selected
          )
          this.CountryList =  matchedKey ? this.countryAssoc[matchedKey] : []
          console.log(' this.CountryList ', this.CountryList)
        }
        console.log(' this.selectedRegionOption ', this.selectedRegionOption, ' this.selectedCountryOption ', this.selectedCountryOption)
        if (this.selectedRegionOption && this.selectedRegionOption != 'Select Region') {
          this.displayForm = true
        }
      },
      setValidatedNominee: function (userData) {
        if (this.checkForDuplicateNominee(userData)) {
          this.validatedNominee = {
            name: userData.firstname + ' ' + userData.lastname,
            slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
            department: userData.department,
            company: (userData.company === '') ? 'Multichoice' : userData.company,
            employeeNum: userData.employeenumber,
            country: userData.country,
            email: userData.UPN,
            lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'][0] : userData.managername,
            lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'][0] : userData.manageremail,
            employeeHierarchy: userData.employeehierarchy
          }
          this.NominationTeamNames.push(this.validatedNominee)
          this.getPageLabel()
        }
      },
      // code to get Label of page
      getPageLabel: function() {
        if (this.NominationTeamNames.length > 1) {
          this.NominationLabel = "Regional Team Of The Month"
        }
        else {
          this.NominationLabel = "Regional Employee Of The Month"
        }
        for (var i = 0; i < this.nominationFields.length; i++) {          
          if (this.nominationFields[i].description === 'Why are you nominating this person?' || this.nominationFields[i].description === 'Why are you nominating this team?') {
            if (this.NominationLabel === "Regional Team Of The Month") {
              this.nominationFields[i].description = 'Why are you nominating this team?'
            }
            if (this.NominationLabel === "Regional Employee Of The Month") {
              this.nominationFields[i].description = 'Why are you nominating this person?'
            }
            break;
          }
        }
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].label === 'Why are you nominating this person?'  || this.nominationContent[i].label === 'Why are you nominating this team?') {
            if (this.NominationLabel === "Regional Team Of The Month") {
              this.nominationContent[i].label = 'Why are you nominating this team?'
            }
            if (this.NominationLabel === "Regional Employee Of The Month") {
              this.nominationContent[i].label = 'Why are you nominating this person?'
            }
            break;
          }
        }
      },
      searchLocalDB: function () {
        this.searchingForEmployeeError = ''
        WordpressRestAPI.getLocalDbUserLookup(this.nominatedPerson.toLowerCase())
          .then(response => {
          if (this.checkForDuplicateNominee(response.data))
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      searchByEmail: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByEmail(this.nominatedPerson)
          .then(response => {
            this.setValidatedNominee(response.data)
            this.showNominationForm = true
            this.searchingForEmployee = false
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the email: ' + this.nominatedPerson + '. Make sure you entered the correct email address or try searching by name and surname'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      searchByUsername: function () {
        this.searchingForEmployeeError = ''
        ADauthentication.getUserInfoByUsername(this.nominatedPerson.replace(' ', '.').toLowerCase())
          .then(response => {
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          })
          .catch(e => {
            if (this.isContractorErrorSet) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
            }
            this.isContractorErrorSet = true
            console.error(e)
          })
      },
      checkForDuplicateNominee: function(data) {
        var self = this
        if (!data.email) {
          data.email = data.UPN
        }
        if (data.email) {
          var dupliEmail = []
          if (self.NominationTeamNames.length > 0) {
            dupliEmail = self.NominationTeamNames.filter(d => data.email && d.email.toLowerCase() ===  data.email.toLowerCase() || d.name.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase())
          }
          if (data.email && self.$store.getters.getUserEmail.toLowerCase() === data.email.toLowerCase() || self.$store.getters.getUserName.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase()) {
            dupliEmail.push(data.email)
            self.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            return false
          }
          if (dupliEmail.length > 0) {
            self.searchingForEmployeeError = 'Duplicate Nominee ' + data.email
            return false
          }
          if (data.employeehierarchy) {
            if (data.employeehierarchy.ishod[0] ===  'Yes') {
              self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
              return false
            }
            if (data.employeehierarchy.excludeCustomerCare[0]) {
              self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS from Customer Care AND CANNOT BE NOMINATED'
              return false
            }
          }
          if (data.employeehierarchy === false) {
            self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
            return false
          }
          return true
        } else {
          self.searchingForEmployeeError = 'Nominee ' + self.nominatedPerson + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
          return false
        }
      },
      getStatus: function () {
        let status = true
        let emailSlug = this.nominatedPerson.replace(/\./g, '-').replace(/@/g, '').toLowerCase()
        let urlString = '?slug='+emailSlug+'&type=RegionalEOM'
        console.log('urlString : '+urlString)
        WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserNominationPerEOM'+urlString)
        .then(response => {
          console.log('review list-> ', response.data)
          if (response.data !== false) {
            console.log('review list-> ', response.data.EOM_count, response.data.TOM_count)
            //if (response.data && response.data.EOM_count && response.data.TOM_count) {
            if (response.data) {              
              // Loop through user_count
              this.createNominationError = ''
              // Check if userStatus is false and alert
              if (response.data.EOM_count > 0) {
                alert(`User ${this.nominatedPerson} is already nominated 1 times this month. Hence you can not nominate this user.`)
              } else if (response.data.TOM_count > 0) {
                alert(`User ${this.nominatedPerson} is already nominated 1 times this month. Hence you can not nominate this user.`)
              } else {
                this.setNominee()
              }
            }
          } else {
            this.contentReady = true
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
          }
        })
        .catch(e => {
            this.contentReady = true
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            console.error(e)
        })
      },
      // code to add user to Nomination list
      setNominee: function () {
        if (this.NominationTeamNames.length < 1) {
          this.searchingForEmployee = true
          this.searchingForEmployeeError = ''
          if (this.isTeamAwards) {
            if (this.nominatedPerson.split(',').length > 50) {
              this.searchingForEmployee = false
              this.searchingForEmployeeError = 'Team Member count can\'t exceed 50!'
            }
            var self = this
            if (this.searchingForEmployee) {
              this.nominatedPerson.split(',').map(function (val, index) {
                let valOrg = val.trim()
                val = val.trim().toLowerCase()
                var dupEmail = self.NominationTeamNames.filter(d => d.email.toLowerCase() === val)
                var dupName = 0
                if (val.indexOf('@') > -1) {
                  dupName = self.NominationTeamNames.filter(d => d.name.toLowerCase() === val)
                }
                if (dupEmail.length > 0 || dupName > 0) {
                  self.searchingForEmployee = false
                } else if (val !== '') {
                  if (val.toLowerCase().indexOf('irdeto') > -1) {
                    alert('Irdeto can\'t be nominated for this Awards.')
                    self.searchingForEmployeeError = 'Irdeto can\'t be nominated for this Awards'
                    self.searchingForEmployee = false
                  } else if (self.$store.getters.getUserEmail.toLowerCase() === val.trim().toLowerCase() || self.$store.getters.getUserName.toLowerCase() === val.trim().toLowerCase()) {
                    alert('You can\'t nominate yourself.')
                    self.searchingForEmployeeError = 'You can\'t nominate yourself'
                    self.searchingForEmployee = false
                  } else {
                    if (val.indexOf('@') > -1) {
                      ADauthentication.getUserInfoByEmail(valOrg)
                        .then(response => {
                          self.setValidatedNominee(response.data)
                          if (self.NominationTeamNames.length > 1) {
                            self.showNominationForm = true
                          }
                          self.searchingForEmployee = false
                        })
                        .catch(e => {
                          self.searchingForEmployee = false
                          self.searchingForEmployeeError = 'Unable to find the Nominee; Please try again!'
                          console.error(e)
                        })
                    } else {
                      ADauthentication.getUserInfoByUsername(val.replace(' ', '.').toLowerCase())
                      .then(response => {
                        console.log(response.data)
                        self.setValidatedNominee(response.data)
                        if (self.NominationTeamNames.length > 1) {
                          self.showNominationForm = true
                        }
                        self.searchingForEmployee = false
                      })
                      .catch(e => {
                        self.searchingForEmployee = false
                        self.searchingForEmployeeError = 'We could not find a user with the names: ' + val + '. Make sure you entered the correct name and surname or try searching by email'
                        console.error(e)
                      })
                    }
                  }
                }
              })
            }
          }
        } else{
          alert('You can only add only 1 person for nomination')
        }
      },
      reload: function () {
        window.location.reload()        
      },
      // Remove single user
      removeNominee: function () {
        this.validatedNominee = {name: '', department: '', employeeNum: ''}
        this.showNominationForm = false
        this.nominatedPerson = ''
        this.madeNomination = false
        this.NominationTeamNames = []
        this.submitClicked = true
        this.nominationContent = []
        this.termsCheckbox = false
        this.setNominationContent(this.award.nomination_fields[0][0])
      },
      // Below code is to remove all members. This function is used for Nominate someone else
      removeTeamNominee: function (index) {
        this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
        if (this.NominationTeamNames.length === 0) {
          this.showNominationForm = false
        }
        this.getPageLabel()
        var slugArray = this.NominationTeamNames.map(function(member) {
          return member.slug;
        });
        // Convert the 'emailArray' to a string with a comma as the separator
        var slugString = slugArray.join(',')
        if (slugString) {
          this.submitClicked = true
        }
      },
      setPostContent: function (type) {
        var content = ''
        var plainContent = ''
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].displayField)
            if (this.nominationContent[i].label === 'Why are you nominating this person?' || this.nominationContent[i].label === 'Why are you nominating this team?') {
              content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
              plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
            }
        }
        return (type === 'nohtml' ? plainContent : content)
      },
      getSelectedPeriod: function() {
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].displayField)
            if (this.nominationContent[i].label === 'Month') {
              return this.nominationContent[i].content
            }
        }
        return ''
      },
      ValidateFields: function (value, type, label) {
        if (type.toLowerCase() === 'email') {
          if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
            alert('Invalid ' + label + ' !')
            return false
          } else if (value.split('@').length > 2) {
            alert ('Only one mail allowed for ' + label + ' !' )
            return false
          }
          return true
        }
      },
      // code to check Nomination Field and Nomination Content for validation
      readyToSubmitNomination: function () {
        var contentPassedValidation = true
        this.searchingForEmployeeError = ''
        if (this.selectedCountryOption == '' || this.selectedCountryOption == 'Select Country') {
          contentPassedValidation = false
          alert('Please select country field')
          return false
        }
        for (var j = 0; j < this.nominationContent.length; j++) {
          this.nominationFields[j].errorClass = ''
          if (this.nominationFields[j].display_field === false) {
            continue
          } else {
            if (this.nominationFields[j].validationMethod) {
              contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
            }
            if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
              this.nominationContent[j].validated = true
            }
            if (this.nominationContent[j].validated === false) {
              contentPassedValidation = false
              this.nominationFields[j].errorClass = 'field-not-validated'
            }
            if (this.isTeamAwards) {
              if (this.NominationTeamNames.length > 50) {
                this.searchingForEmployeeError = 'Team Member count can\'t exceeds 50!'
                contentPassedValidation = false
              }
            }
            // Stop immedieatly any field validation is false
            if (contentPassedValidation === false)
              break;
          }
        }
        return this.termsCheckbox && contentPassedValidation
      },
      addMediaToNominationPost: function (mediaID, postID) {
        var sendNomination = {
          method: 'POST',
          data: {
            supporting_documentation: mediaID
          },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
          .then(function (response) {
            self.supportingDocLength = 0
            self.supportingDocList = []
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      uploadSupportingDocumentation: function (postID, supportingDoc) {
        var self = this
        var formData = new FormData()
        formData.append('file', supportingDoc)
        if (self.NominationTeamNames.length === 1) {
          //Employee of the month
          formData.append('title', postID + ' Supporting Image Media of Employee of the Month for ' + self.validatedNominee.name)
          formData.append('caption', postID + ' Supporting Image Media of Employee of the Month for ' + self.validatedNominee.name)
        } else if (self.NominationTeamNames.length) {
          //Team of the month
          formData.append('title', postID + ' Supporting Image Media for Team of the Month by ' + self.$store.getters.getUserName)
          formData.append('caption', postID + ' Supporting Image Media for Team of the Month by ' + self.$store.getters.getUserName)
        }

        var uploadMedia = {
          method: 'POST',
          processData: false,
          contentType: false,
          data: formData,
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        console.log(' formData ', formData , uploadMedia)
        WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
          .then(function (response) {
            self.supportingDocList.push(response.data.id)
            if (self.supportingDocLength === self.supportingDocList.length) {
              self.addMediaToNominationPost(self.supportingDocList, postID)
            }
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      checkForMediaUpload: function (postID) {
        var supportingDoc = this.nominationContent.filter(x => {
          return x.label.indexOf('If applicable, please attach Image for Award') > -1 && x.content !== ''
        })
        console.log(' supportingDoc ', supportingDoc)
        if (supportingDoc.length > 0) {
          const filesArray = Array.from(supportingDoc[0].content)
          // Traverse the array using forEach
          this.supportingDocLength = supportingDoc[0].content.length
          filesArray.forEach(file => {
            console.log('supportingDoc file ', file)
            this.uploadSupportingDocumentation(postID, file)
          });
        }
      },
      assignUserCommunities: function () {
        if (this.$store.getters.getUserCommunityIDstring) {
          return this.award.community_categories.filter(
            f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
          )
        } else {
          return []
        }
      },
      getNominationEventCategory: function () {
        var self = this
        var nominationEventCategory = []
        nominationEventCategory.push('20')
        if (self.NominationTeamNames.length === 1) {
          // Regional EOM
          nominationEventCategory.push('141')
        }
        return nominationEventCategory
      },
      getNominationTitle: function () {
        var self = this
        var nominationTitle = ''
        if (self.NominationTeamNames.length === 1){
          nominationTitle = self.validatedNominee.name + ', Regional Employee of the Month'
        }
        else if (self.NominationTeamNames.length > 1){
          nominationTitle = 'Regional Team of the month by ' + self.$store.getters.getProfileDetails.name
        }
        return nominationTitle
      },
      // Below code is for submitting Nomination form
      createNominationEntry: function () {
        this.showNominationForm = false
        this.creatingNomination = true
        var self = this
        if (self.$store.state.UserProfile.currentUser.meta.communities !== undefined && self.$store.state.UserProfile.currentUser.meta.communities.length > 0) {
          var employeeCompany = self.$store.state.UserProfile.currentUser.meta.communities
        } else {
          var employeeCompany = self.validatedNominee.department
        }
        if (self.$store.state.UserProfile.currentUser.meta.employeeNumber !== undefined && self.$store.state.UserProfile.currentUser.meta.employeeNumber.length > 0) {
          var employeeNumber = self.$store.state.UserProfile.currentUser.meta.employeeNumber
        } else {
          var employeeNumber = self.validatedNominee.employeeNum
        }
        var sendNomination = {
          method: 'POST',
          data: {
            title: self.getNominationTitle(),
            nomination_event_category: self.getNominationEventCategory(),
            community_categories: self.assignUserCommunities(),
            nomination_approve_decline: 'Accepted',
            nominee_name: self.validatedNominee.name,
            nominee_slug: self.validatedNominee.slug,
            nominee_company: self.validatedNominee.company,
            status: 'publish',
            content: self.setPostContent('html'),
            nominationdata: self.setPostContent('nohtml'),
            selectionperiod: self.getSelectedPeriod(),
            EmployeeAwardRegion: self.selectedRegionOption,
            EmployeeAwardCountry: self.selectedCountryOption,
            nominator_details: [{
              'employee-number': employeeNumber,
              'employee-company': employeeCompany
            }]
          },
          headers: {
            'Authorization': localStorage.getItem('userToken'),
            'Content-Type': 'application/json'
          },
          json: true
        }
        sendNomination.data.bigups_ecards = []
        sendNomination.data.teamnominationworkflow = []
        var d = new Date()
        let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()

        // Push Line Manager
        if (self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
        }

        // Push Exco2 Manager
        if (self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': '', 'project_sponsor_datetime' : ''})
        }

        // Push HRBP
        if (self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0]) {
          sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status' : 'Approve', 'project_sponsor_datetime': nominationDate})
        }
        if (self.NominationTeamNames.length > 1) {
          sendNomination.data.isteamaward = 'true'
        }
        if (self.NominationTeamNames.length > 1) {
          sendNomination.data.nominationteam = []
          sendNomination.data.nominee_name = ''
          sendNomination.data.nominee_slug = ''
          for (var i = 0; i < self.NominationTeamNames.length; i++) {
            sendNomination.data.nominationteam.push({
              'member_name': self.NominationTeamNames[i].name,
              'member_approve_reject': 'Accepted',
              'member_company': self.NominationTeamNames[i].company,
              'member_employee_number': self.NominationTeamNames[i].employeeNum,
              'member_slug': self.NominationTeamNames[i].slug,
              'email': self.NominationTeamNames[i].email
            })
          }
        }
        WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination')
        .then(function (response) {
          console.log('  response ', response.data)
          self.checkForMediaUpload(response.data.id)
          self.promoteToReview(response.data, 'exco2', 'Exco2')
          self.sendEmailNotificationToNominator(response.data.id)
          self.madeNomination = true
          self.creatingNomination = false
        })
        .catch(function (e) {
          self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
          console.error(e)
        })
      },
      sendEmailNotificationToNominator: function (nominationID) {
        console.log(' sendEmailNotificationToNominator called ')
        let emailBody = NominationNotification.confirmationOfNominationBody({
          nominee: this.validatedNominee.name,
          nominator: this.$store.getters.getUserName,
          awardName: 'A Regional Employee of the month',
          prizeMoney: this.award.nomination_award_prize[0],
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-employee-award+' + nominationID,
          closingDate: this.award.nomination_event_time_frame[0][0][0].nomination_event_date_to
        })
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: this.$store.getters.getUserEmail,
            subject: 'You sent a nomination on ThinkTank',
            message: emailBody
          },
          json: true
        }
  
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data, 'inside respose sendEmail')
          })
          .catch(function (e) {
            console.error(e)
          })
      },
      promoteToReview: function (nominationDetails, reviewer, reviewerLabel) {
        let emailBody = ''
        var tempEmail = []
        if (nominationDetails.id) {
          var title = nominationDetails.title.raw.toLowerCase()
          if (title.includes('employee')) {
            var nominationType = 'A Regional Employee of the Month'
          }
          if (title.includes('team')) {
            var nominationType = 'A Team of the Month'
          }
          // TODO: Change the Email template once received
          emailBody = NominationNotification.nominationBodyForEmployeeAwardNotification({
            reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-employee-award+' + nominationDetails.id + '+' + reviewerLabel,            
            position: reviewerLabel,
            nominationType: nominationType
          })
          tempEmail = nominationDetails.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === reviewer.toLowerCase())
          var emailNominationNotification = {
            method: 'POST',
            data: {
              to: tempEmail[0].project_sponsor_email,
              subject: 'You have been identified as ' + reviewerLabel + ' on ThinkTank',
              message: emailBody
            },
            json: true
          }
          WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
        }
      },
      submitNomination: function () {
        this.submitClicked = false
        if (this.readyToSubmitNomination()) {
          var selectionPeriod = self.getSelectedPeriod()
          let emailSlug = this.nominatedPerson.replace(/\./g, '-').replace(/@/g, '').toLowerCase()
          let urlString = '?slug='+emailSlug+'&type=RegionalEOM&selectionPeriod='+selectionPeriod
          console.log('urlString : '+urlString)
          WordpressRestAPI.getCustomViewContent('getNomination/v1/getUserNominationPerEOMBeforeSubmit'+urlString)
          .then(response => {
            console.log('review list-> ', response.data)
            if (response.data !== false) {
              console.log('review list-> ', response.data.EOM_count, response.data.TOM_count)
              //if (response.data && response.data.EOM_count && response.data.TOM_count) {
              if (response.data) {
                // Loop through user_count
                this.createNominationError = ''
                // Check if userStatus is false and alert
                if (response.data.EOM_count > 0) {
                  this.submitClicked = true
                  alert(`User ${this.nominatedPerson} is already nominated 1 times this month. Hence you can not nominate this user.`)
                } else {
                  this.createNominationEntry()
                }
              }
            } else {
              this.contentReady = true
              this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            }
          })
          .catch(e => {
              this.contentReady = true
              this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
              console.error(e)
          })
        } else {
          this.submitClicked = true
        }
      },
      fieldUpdated: function (fieldDetails) {
        for (var i = 0; i < this.nominationContent.length; i++) {
          if (this.nominationContent[i].label === fieldDetails.label) {
            this.nominationContent[i].content = fieldDetails.content
            this.nominationContent[i].validated = fieldDetails.validated
            this.nominationContent[i].displayField = fieldDetails.displayField
            break
          }
        }
      },
      setNominationContent: function (nominationFields) {        
        var self = this
        self.nominationFields = nominationFields.map(function (x, index) {
          var displayFieldVal = x.display_field === "No" ? false : true
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod
          }
        })

        if (self.nominationContent.length > 1) {
          self.nominationContent = self.nominationFields.map(function (x, i) {
            return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
          })
        } else  {
          self.nominationContent = self.nominationFields.map(function (x) {
            return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
          })
        }
      },
      loadContent: function () {
        this.madeNomination = false
        this.nominatedPerson = ''
        document.title = this.$route.name + ' - ThinkTank'
        WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=137&_embed&per_page=1')
        .then(response => {
          console.log(' response.data ', response.data)
          this.award = response.data[0]
          console.log(' this.award ', this.award, this.award.content.rendered)
          this.contentReady = true
          self = this
          if (this.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            self.getHCBPRegionList()
            .then(() => {
              console.log('Nominations fetching complete.');
              this.NominationTeamNames = []
              this.isTeamAwards = true
              this.NominationButtonText = 'Add Nominee'
              this.NominationLabel = 'Regional Employee of the Month Nomination'
              this.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
              this.setNominationContent(this.award.nomination_fields[0][0])              
            })
            .catch(error => {
              console.error('Error:', error);
              // Handle the error if needed
            });
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
      },
      getHCBPRegionList: async function () {
        try {
          const response = await WordpressRestAPI.getCustomViewContent('thinktank_authentication/v1/getRegionListAsPerHCBPEOM?email=' + this.userDetails.email)
          if (response.data) {
            this.RegionList = response.data.RegionList
            this.countryAssoc = response.data.countryAssoc
          }
        } catch (e) {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.';
          console.error(e);
          this.contentReady = true;
        }
      },
      searchNomineeList: function (newQuery) {
        if ( newQuery.length > 2 )
        WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
          .then((res) => {
            this.nomineesList = res.data
          })
      }
    },
    created () {
      console.log(' viewEmployeeAwardsRegional ', this.viewEmployeeAwardsRegional)
      document.title = this.$route.name + ' - ThinkTank'
      var self = this
      var usernameOptions = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
        .then(function (userResponse) {
          self.userDetails = userResponse.data
          if (self.userDetails) {
            console.log(' self.userDetails ', self.userDetails)
            console.log(' self.userDetails ', self.userDetails.email)
            self.loadContent()
          }
      })
      .catch(e => {
        console.error(e)
      })
    },
    watch: {
      viewEmployeeAwardsRegional (newDetails, oldDetails) {
        console.log('watch viewEmployeeAwardsRegional called')
        if (!this.$store.getters.isAdmin) {
          //this.loadContent()
        }
      },
      nominatedPerson (newQuery, oldQuery) { 
        if (newQuery != '')
          this.searchNomineeList(newQuery) 
      },
      '$route' (to, from) {
        this.contentReady = false
        this.loadContent()
      }
    }
  }
  </script>
  
  <style lang="less">
    .featuredImg {
      img {
        width: 100%;
      }
    }
    .box {.icon { text-align: center; position: relative; }}
    .box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
    .box { .icon:hover { .image { background: #63B76C; }}}
    .box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
    .box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
    .box { .icon { .infoaqua { background-color:#CEF6F8; }}}
    .box { .icon { .infogrey { background-color:#F8F8F8; }}}
    .box { .icon { .infowhite { background-color:#FFFFFF; }}}
    .box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
    .box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
    .box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
    .box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
    .box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
    .box { .icon { .info { p {margin-left: 40px;}}}}
    .aquacolor {color:#09ced6;}
    .navycolor {color: navy;}
  </style>


// WEBPACK FOOTER //
// src/components/routes/VEAwardsEmployeeRegional.vue